import ShippingDetail from 'components/invoicing/ShippingDetail/ShippingDetail';

/**
 * Props for the ShippingSection component.
 */
interface ShippingSectionProps {
  /**
   * Flag indicating whether the component is in a loading state.
   */
  isLoading: boolean;

  /**
   * Function to fetch shipping options.
   * @param data - The input data for fetching shipping options.
   * @returns A promise that resolves to an array of shipping options.
   */
}

/**
 * Component for the shipping section.
 *
 * @param isLoading - Flag indicating whether the component is in a loading state.
 */
export const ShippingSection: React.FC<ShippingSectionProps> = ({ isLoading }) => {
  return (
    <div className="flex flex-col">
      <div className="font-medium">2. Select shipping</div>
      <ShippingDetail isLoading={isLoading} />
    </div>
  );
};
